import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'

// Pages
import { LoginPage } from './pages/Login'
import { AuthCallbackPage } from './pages/AuthCallback'
import { DashboardLayout } from './components/DashboardLayout'
import { HomePage } from './pages/Home'
import { NudgeLibraryPage } from './pages/NudgeLibrary'
import { AnalyticsPage } from './pages/Analytics'
import { TeamPage } from './pages/Team'
import { SettingsPage } from './pages/Settings'
import { AccountabilityPage } from './pages/Accountability'
import { SecurityPage } from './pages/Security'
import { PrivacyPage } from './pages/Privacy'
import { PricingScreen } from './pages/Pricing'
import { PlatformAdminPage } from './pages/PlatformAdmin'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthStore()

  if (loading) return <div className="flex items-center justify-center h-screen" style={{background: '#F5F2EA', color: '#2A7A8A'}}>Loading…</div>
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  const fetchMe = useAuthStore(s => s.fetchMe)

  useEffect(() => {
    // Restore session from localStorage token on mount
    const token = localStorage.getItem('duva_token')
    if (token) fetchMe()
  }, [fetchMe])

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/admin" element={<PlatformAdminPage />} />

      {/* Protected — wrapped in sidebar layout */}
      <Route path="/" element={
        <RequireAuth>
          <DashboardLayout />
        </RequireAuth>
      }>
        <Route index element={<HomePage />} />
        <Route path="library" element={<NudgeLibraryPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="accountability" element={<AccountabilityPage />} />
        <Route path="pricing" element={<PricingScreen />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
